import React, { useState } from 'react';
import { Helmet } from "react-helmet";


function Promotion() {
  const [visibleId, setVisibleId] = useState(null); // State to track which element should be visible

  // Function to handle click event on promotion links
  const handlePromotionClick = (id) => {
    setVisibleId(id); // Update the state to show the corresponding element
  };
  
  return (
    <>
      <Helmet>
          <meta charSet="utf-8" />
            <title>Discover and Enjoy Online Casino Bonus at SG8 Philippines</title> <link rel="icon" href="/images/sg8-icon.webp" sizes="32x32" />
      </Helmet>

      <div className="main-wrapper">
        <div className="main-content-area">
            <div className="page-headlines-container">
              <div className="page-h2-text-style">
                <h2>Promotions</h2> <span>Get our Best Deals from SG8.Casino</span>
              </div>
            </div>
            <div className="promotionContentarea">
              <div className="promotionWrapper">
                <div className="promotionBox">
                  <img src="/images/depositbonus.jpg" alt="" />
                  <div className="promotionContent">
                    <p className="promotion-title">Deposit Bonus</p>
                    <p className="promotion-info">Up to 150% bonus on 1st</p>
                    <div className="promolink-container">
                      <a className="yellow-btn" onClick={() => handlePromotionClick('depositbonus')}>T&C</a>
                    </div>
                  </div>
                </div>
                <div className="promotionBox">
                  <img src="/images/paydaybonus.jpg" alt="" />
                  <div className="promotionContent">
                    <p className="promotion-title">Payday Bonus</p>
                    <p className="promotion-info">Payday Bonus at SG8 Casino</p>
                    <div className="promolink-container">
                      <a className="yellow-btn" onClick={() => handlePromotionClick('paydaybonus')}>T&C</a>
                    </div>
                  </div>
                </div>
                <div className="promotionBox">
                  <img src="/images/birthday-bonus.jpg" alt="" />
                  <div className="promotionContent">
                    <p className="promotion-title">Birthday Bonus</p>
                    <p className="promotion-info">Come and Celebrate your Birthday</p>
                    <div className="promolink-container">
                      <a className="yellow-btn" onClick={() => handlePromotionClick('birthdaybonus')}>T&C</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div>
        {/* Conditional rendering to show the T&C content based on the state */}
        {visibleId === 'depositbonus' && <div className="fade-in">T&C Content for Deposit Bonus</div>}
        {visibleId === 'paydaybonus' && <div className="fade-in">T&C Content for Payday Bonus</div>}
        {visibleId === 'birthdaybonus' && <div className="fade-in">T&C Content for Birthday Bonus</div>}
      </div>

      <div className="main-content-wrapper">
        <div className="text-content-area">
            <h2 className="text-content-title">Who is SG8 Casino?</h2>
            <p>Explore the vibrant essence of Philippines’ online casino at SG8 Casino – your meticulously crafted online gaming haven designed for ardent enthusiasts. Embark on an exhilarating journey into the world of online entertainment, promising a fusion of thrills, wins, and boundless excitement to captivate every player’s senses.</p>
            <span className="text-content-sub-title">How to Register at SG8 Casino?</span>
            <p>At SG8 Casino, we revolutionize the online gaming landscape with a spectrum of meticulously curated options, catering to the discerning tastes of the Filipino gaming community. From captivating Online Slots to Live Casino extravaganzas and heart-racing Sports Betting, all fortified by PAGCOR’s seal of safety and unwavering reliability.</p>
            <span className="text-content-sub-title">How to Register at SG8 Casino?</span>
            <p>Step into a journey in our Live Casino, powered by Evolution Gaming. Encounter the captivating suspense of Live Baccarat, the strategic depth of Blackjack, the spinning excitement of Live Roulette, and the dynamic entertainment of Crazy Time.</p>
            <div className="payment-menthod-container">
              <img src="/images/gcash-maya.webp" alt="" style={{width: `unset`}}/>
              <img src="/images/dragonpay.webp" alt="" style={{width: `unset`}}/>
              <img src="/images/fortunepay.webp" alt="" style={{width: `unset`}}/>
              <img src="/images/lazada.webp" alt="" style={{width: `unset`}}/>
            </div>
            <div></div>
        </div>
      </div>
    </>
  )
}

export default Promotion